import { createFileRoute } from '@tanstack/react-router';
import { JobsPage } from '../components/community/JobsPage';

export const Route = createFileRoute('/community/jobs/')({
  component: JobsPage,
});
